import { useEffect, useState } from "react";
import {
  Spinner,
  Button,
  Input,
  Form,
  Label,
} from "reactstrap";
import axiosInstance from "../request";
import { URL } from "../api";
import getPrivilegeList from "./PrivilegeList";
import toast, { Toaster } from "react-hot-toast";
const CollectionList = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refundingId, setRefundingId] = useState(null); 
  const [activeFilters, setActiveFilters] = useState({});


  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const privilegeList = getPrivilegeList();

const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage] = useState(10);
const [hasNextPage, setHasNextPage] = useState(false);
const currentRows = collections;


const companyCode = localStorage.getItem("companyCode");
const branchCode = localStorage.getItem("branch_code");


  const formatDateForAPI = (dateString) => dateString;

  const handleRefund = async (item) => {
  // Logic: Only proceed if extra_amount > 0 and is_refunded is not 1
  if (!(item.extra_amount > 0 && item.is_refunded !== 1)) {
    return;
  }

  const confirmRefund = window.confirm(`Proceed with refunding ₹${item.extra_amount} for Tran ID: ${item.tran_id}?`);
  if (!confirmRefund) return;

  setRefundingId(item.tran_id); // Show spinner for this specific row
  try {
    const response = await axiosInstance.post(`${URL.RAZORPAY_REFUND}?tranId=${item.tran_id}`, {
      partial: 1,
      amount: item.extra_amount
    });

    toast.success("Refund successfully processed!");
    fetchCollections(currentPage, activeFilters); // Refresh list to update data
  } catch (err) {
    console.error("Refund Error:", err);
    // Capture backend error message or show default
    const errorMsg = err.response?.data?.message || "Refund failed. Please check backend logs.";
    toast.error(errorMsg);
  } finally {
    setRefundingId(null);
  }
};


  const formatDateForDisplay = (isoDate) => {
    if (!isoDate) return "-";
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
  };


  const fetchCollections = async (page = 1, filters = {}) => {
  setLoading(true);
  try {
    const params = new URLSearchParams(filters);

    // company / branch filter
if (companyCode) params.append("companyCode", companyCode);
if (companyCode && branchCode) params.append("branchCode", branchCode);

    params.append("page", page - 1); // backend is 0-based
    params.append("size", rowsPerPage);

    const response = await axiosInstance.get(
      `${URL.COLLECTION_LIST}?${params.toString()}`
    );

    const data = Array.isArray(response.data) ? response.data : [];

    setCollections(data);
    setCurrentPage(page);

    // 🔑 SAME LOGIC AS LOAN LIST
    setHasNextPage(data.length === rowsPerPage);

  } catch (err) {
    console.error("Error fetching collections:", err);
    setCollections([]);
    setHasNextPage(false);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  fetchCollections(1, {});
}, []);


  const handleSearch = (e) => {
  e.preventDefault();

  const filters = {};
  if (filterValue.trim()) filters[filterType] = filterValue.trim();
  if (fromDate) filters.fromDate = formatDateForAPI(fromDate);
  if (toDate) filters.toDate = formatDateForAPI(toDate);

  setActiveFilters(filters);  
fetchCollections(1, filters);

};


  const currentLabel = {
    customerId: "Customer ID",
    loanId: "Loan ID",
    paymentId: "Payment ID",
    tranId: "Tran ID",
  }[filterType];



  return (
    <div className="container" style={{ fontSize: "14px" }}>
      <h3 className="mb-4">Collection List</h3>

      {/* Filter Form */}
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="row g-3">
          <div className="col-md-2">
            <Label className="form-label fw-bold">Filter Type</Label>
            <Input
              type="select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              bsSize="sm"
            >
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
              <option value="paymentId">Payment ID</option>
              <option value="tranId">Tran ID</option>
            </Input>
          </div>
          <div className="col-md-3">
            <Label className="form-label fw-bold">{currentLabel}</Label>
            <Input
              type="text"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              placeholder={`Enter ${currentLabel}`}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2">
            <Label className="form-label fw-bold">From Date</Label>
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2">
            <Label className="form-label fw-bold">To Date</Label>
            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <Button color="primary" type="submit" size="sm">
              Search
            </Button>
          </div>
        </div>
      </Form>

      {/* Loading */}
   {/*     {loading ? (
        <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
          <Spinner size="sm" /> <span>Loading collections...</span>
        </div>
      ) : (
        <>
          <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark">
                <tr>
                  <th>S.No.</th>
                  <th>Cust Name</th>
                  <th>C.ID</th>
                  <th>L.ID</th>
                  <th>Fintech Name</th>
                  <th>Pay.ID</th>
                  <th>Tran ID</th>
                  <th>Collection Date</th>
                  <th>Amount (₹)</th>
                  <th>Mode</th>
                  <th>Extra</th>
                  <th>Refund</th>
                  {privilegeList.loanDetailsView && <th>Refund Action</th>} 
                  {privilegeList.loanDetailsView && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {currentRows.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.full_name || "-"}</td>
                    <td>{item.customer_id || "-"}</td>
                    <td>{item.loan_id || "-"}</td>
                    <td>{item.fintech_name || "-"}</td>
                    <td>{item.payment_id || "-"}</td>
                    <td>{item.tran_id || "-"}</td>
                    <td>{formatDateForDisplay(item.tran_date)}</td>
                    <td>₹{item.tran_amount?.toLocaleString() || "0"}</td>
                    <td>{item.tran_type_value || "-"}</td>
                    <td>{item.extra_amount ?? 0}</td>
                    <td>{item.refunded_amount ?? 0}</td>
                    {privilegeList.loanDetailsView && (
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            (window.location.href = `#/LoanView?loanId=${item.loan_id}`)
                          }
                        >
                          View
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                {collections.length === 0 && (
                  <tr>
                    <td colSpan="12" className="text-center text-muted">
                      No collection records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>   */}

          {/* Loading */}
{loading ? (
  <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
    <Spinner size="sm" /> <span>Loading collections...</span>
  </div>
) : (
  <>
    <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
      <table className="table table-bordered table-hover align-middle">
        <thead className="table-dark">
          <tr>
            <th>S.No.</th>
            <th>Cust Name</th>
            <th>C.ID</th>
            <th>L.ID</th>
            <th>Fintech Name</th>
            <th>Pay.ID</th>
            <th>Tran ID</th>
            <th>Collection Date</th>
            <th>Amount (₹)</th>
            <th>Mode</th>
            <th>Extra</th>
            <th>Refund</th>
            {/* 1. Header for Refund Action */}
            {privilegeList.loanDetailsView && <th>Refund Action</th>} 
            {privilegeList.loanDetailsView && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((item, index) => {
            // 2. Logic: Button is active ONLY IF extra > 0 AND is_refunded is 0
            const canRefund = item.extra_amount > 0 && item.is_refunded !== 1;

            return (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{item.full_name || "-"}</td>
                <td>{item.customer_id || "-"}</td>
                <td>{item.loan_id || "-"}</td>
                <td>{item.fintech_name || "-"}</td>
                <td>{item.payment_id || "-"}</td>
                <td>{item.tran_id || "-"}</td>
                <td>{formatDateForDisplay(item.tran_date)}</td>
                <td>₹{item.tran_amount?.toLocaleString() || "0"}</td>
                <td>{item.tran_type_value || "-"}</td>
                <td>{item.extra_amount ?? 0}</td>
                <td>{item.refunded_amount ?? 0}</td>

                {/* 3. Refund Action Button Logic */}
                {privilegeList.loanDetailsView && (
                  <td>
                    <Button
                      color={canRefund ? "warning" : "secondary"}
                      size="sm"
                      // Disabled if logic fails OR if this specific row is currently processing
                      disabled={!canRefund || refundingId === item.tran_id}
                      onClick={() => handleRefund(item)}
                      style={{ 
                        opacity: canRefund ? 1 : 0.5, 
                        cursor: canRefund ? "pointer" : "not-allowed",
                        fontSize: "12px",
                        fontWeight: "bold"
                      }}
                    >
                      {refundingId === item.tran_id ? (
                        <Spinner size="sm" />
                      ) : (
                        "Refund"
                      )}
                    </Button>
                  </td>
                )}

                {privilegeList.loanDetailsView && (
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() =>
                        (window.location.href = `#/LoanView?loanId=${item.loan_id}`)
                      }
                    >
                      View
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
          {collections.length === 0 && (
            <tr>
              <td colSpan="14" className="text-center text-muted">
                No collection records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

<div className="d-flex justify-content-center mt-3">
  <div className="d-flex align-items-center" style={{ gap: "10px" }}>

<button
  className="btn btn-sm btn-outline-primary"
  onClick={() => fetchCollections(currentPage - 1, activeFilters)}
  disabled={currentPage === 1}
>
  Prev
</button>

<span className="fw-semibold">Page {currentPage}</span>

{hasNextPage && <span className="text-muted">...</span>}

<button
  className="btn btn-sm btn-outline-primary"
  onClick={() => fetchCollections(currentPage + 1, activeFilters)}
  disabled={!hasNextPage}
>
  Next
</button>


  </div>
</div>

        </>
      )}
    </div>
  );
};

export default CollectionList;
